import { RootState } from 'store/store.types';
import { ContentRegistry } from 'component/page/detail/DetailPageModularize/ContentRegistry';
import { ContentConfig, ContentHandlerMetaInfo } from 'component/page/detail/DetailPageModularize/contentRegistry.type';

export const getCustomMetaFromContentHandler = (content: ContentConfig, state: RootState): ContentHandlerMetaInfo => {
    const contentRegistry = ContentRegistry[content.content];

    const titleCms = content.contentProps && 'titleCms' in content.contentProps && content.contentProps.titleCms ? content.contentProps.titleCms : contentRegistry.titleCms;

    const dynamicTitle = contentRegistry.getTitle?.(state);

    return {
        titleCms: titleCms || 0,
        dynamicTitle: dynamicTitle || undefined,
        href: (content.contentProps && 'href' in content.contentProps ? content.contentProps.href : contentRegistry.href) || '',
        elementName: (content.contentProps && 'elementName' in content.contentProps ? content.contentProps.elementName : contentRegistry.elementName) || '',
    };
};
